import { render, staticRenderFns } from "./SingleLink.vue?vue&type=template&id=066dfa7b&"
import script from "./SingleLink.vue?vue&type=script&lang=js&"
export * from "./SingleLink.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports